/* eslint-disable react/jsx-no-target-blank */
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { AsideMenuItem } from './AsideMenuItem'
import { useIntl } from 'react-intl'
import clsx from 'clsx'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { useAuth } from '../../../../app/modules/auth'

export function AsideMenuMain() {
  //
  const params = useParams()
  const intl = useIntl()
  const navigate = useNavigate()
  const path = useLocation().pathname.split('/')[1]

  // Icon will be navigate to alert list if no permission
  const { currentUser, logout } = useAuth()
  // const statisticPermission = currentUser?.permissions?.find((permissions) => permissions?.service === 'STATISTICS');
  // const haveDashBoardPermission = statisticPermission?.access?.some((access) => access === 'dashboard.read') ?? false;

  const siPermission = currentUser?.permissions?.find((permissions) => permissions?.service === 'SI');
  const haveAddBrandPermission = siPermission?.access?.some((access) => access === 'brand.create') ?? false;

  const siteIntelligencePermission = currentUser?.permissions?.find((permissions) => permissions?.service === 'SITE_INTELLIGENCE');
  const haveReadSitePermission = siteIntelligencePermission?.access?.some((access) => access === 'site.read') ?? false;
  const haveReadKeywordPermission = siteIntelligencePermission?.access?.some((access) => access === 'keyword.read') ?? false;
  const haveReadBrandPermission = siteIntelligencePermission?.access?.some((access) => access === 'brand.read') ?? false;
  const haveReadSchedulePermission = siteIntelligencePermission?.access?.some((access) => access === 'si.schedule.read') ?? false;
  const haveReviewPermission = siteIntelligencePermission?.access?.some((access) => access === 'si.review') ?? false;

  const tldPermission = currentUser?.permissions?.find((permissions) => permissions?.service === 'TLD');
  const haveReadTldTransactionsPermission = tldPermission?.access?.some((access) => access === 'transactions.read') ?? false;
  const haveReadTldClientsPermission = tldPermission?.access?.some((access) => access === 'merchants.read') ?? false;
  const haveReadTldQuotasPermission = tldPermission?.access?.some((access) => access === 'quotas.read') ?? false;
  const haveReadTldRemarkOptionsPermission = tldPermission?.access?.some((access) => access === 'remark_options.read') ?? false;
  const haveReviewTldReportsPermission = tldPermission?.access?.some((access) => access === 'reports.review') ?? false;
  const haveReadTldAuditLogsPermission = tldPermission?.access?.some((access) => access === 'audit_logs.read') ?? false;

  const ethocaPermission = currentUser?.permissions?.find((permissions) => permissions?.service === 'ETHOCA');
  const haveEthocaCreditPermission = ethocaPermission?.access?.some((access) => access === 'alerts.credit') ?? false;

  return (
    <>
      <div className='px-2 pt-5'>
        {/* {haveDashBoardPermission && <AsideMenuItem
          to='/dashboard'
          title='Dashboard'
          fontIcon='bi-archive'
          icon='/media/icons/duotune/graphs/gra007.svg'
        />} */}

        <div className='menu-item'>
          <div className='menu-content pt-5 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Services</span>
          </div>
        </div>

        <AsideMenuItemWithSub
          to='/site-inspect'
          title='SiteInspect'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/abstract/abs022.svg'
        >
          {/* {haveReadSitePermission && <AsideMenuItem to='/site-inspect/sites/list' title='Sites' hasBullet={true} />} */}
          <AsideMenuItem to='/site-inspect/reports/list' title='Reports' hasBullet={true} />
          {/* <AsideMenuItem to='/site-inspect/company-info-related/list' title='Company Info Related' hasBullet={true} />
          {haveReadKeywordPermission && <AsideMenuItemWithSub to='/site-inspect/keywords' title='Keywords' hasBullet={true}>
            <AsideMenuItem to='/site-inspect/keywords/list' title='List' hasBullet={true} />
            <AsideMenuItem to='/site-inspect/keywords/extracted/list' title='Extracted' hasBullet={true} />
          </AsideMenuItemWithSub>}
          {haveReadBrandPermission && <AsideMenuItem to='/site-inspect/brands/list' title='Brands' hasBullet={true} />} */}
          {haveReadSchedulePermission && <AsideMenuItem to='/site-inspect/schedules/list' title='Schedules' hasBullet={true} />}
          {haveReviewPermission && (
            <>
              <AsideMenuItem to='/site-inspect/remarks/list' title='Remarks' hasBullet={true} />
              <AsideMenuItemWithSub to='/site-inspect/reviews' title='Reviews' hasBullet={true}>
                <AsideMenuItem to='/site-inspect/reviews/list' title='List' hasBullet={true} />
                <AsideMenuItem
                  to='/site-inspect/reviews/history/list'
                  title='History'
                  hasBullet={true}
                />
              </AsideMenuItemWithSub>
            </>
          )}
          <AsideMenuItem to='/site-inspect/clients/list' title='Clients' hasBullet={true} />
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub
          to='/tld'
          title='TLD'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/abstract/abs013.svg'
        >
          <AsideMenuItem to='/tld/sites/list' title='Sites' hasBullet={true} />
          <AsideMenuItem to='/tld/reports/list' title='Reports' hasBullet={true} />
          {/* {haveReadTldTransactionsPermission && <AsideMenuItem to='/tld/transactions/list' title='Transactions' hasBullet={true} />} */}
          {/* {haveReadTldClientsPermission && <AsideMenuItem to='/tld/clients/list' title='Clients' hasBullet={true} />} */}
          {/* {haveReadTldQuotasPermission && <AsideMenuItem to='/tld/quotas/list' title='Quotas' hasBullet={true} />} */}
          {/* {haveReadTldRemarkOptionsPermission && <AsideMenuItem to='/tld/remarks/list' title='Remarks' hasBullet={true} />} */}
          {/* {haveReviewTldReportsPermission && <AsideMenuItem to='/tld/reviews/list' title='Reviews' hasBullet={true} />}
          {haveReviewTldReportsPermission && <AsideMenuItem to='/tld/review-reports/list' title='Review Reports' hasBullet={true} />} */}
          {/* {haveReadTldAuditLogsPermission && <AsideMenuItem to='/tld/audit-logs/list' title='Audit Logs' hasBullet={true} />} */}
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub
          to='/ethoca'
          title='Ethoca Alert'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/general/gen007.svg'
        >
          <AsideMenuItemWithSub to='/ethoca/alerts' title='Alerts' hasBullet={true}>
            <AsideMenuItem
              to='/ethoca/alerts/list'
              title='List'
              hasBullet={true}
            />
            <AsideMenuItem
              to='/ethoca/alerts/upload-status/list'
              title='Upload Status'
              hasBullet={true}
            />
          </AsideMenuItemWithSub>

          <AsideMenuItem to='/ethoca/descriptors/list' title='Descriptors' hasBullet={true} />

          {/* <AsideMenuItemWithSub to='/ethoca/clients' title='Clients' hasBullet={true}> */}
          <AsideMenuItem to='/ethoca/clients/list' title='Clients' hasBullet={true} />
          {/* <AsideMenuItem to='/ethoca/clients/tree' title='Tree' hasBullet={true} /> */}
          {/* </AsideMenuItemWithSub> */}

          {/* <AsideMenuItem to='/ethoca/users/list' title='Users' hasBullet={true} /> */}
          <AsideMenuItem to='/ethoca/enquiries/list' title='Enquiries' hasBullet={true} />
          {haveEthocaCreditPermission && <AsideMenuItem to='/ethoca/credits/list' title='Credits' hasBullet={true} />}
          {/* <AsideMenuItem to='/ethoca/audit-logs/list' title='Audit Logs' hasBullet={true} /> */}
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub
          to='/rdr'
          title='Verifi RDR'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/abstract/abs023.svg'
        >
          <AsideMenuItem to='/rdr/cases/list' title='Cases' hasBullet={true} />
          <AsideMenuItem to='/rdr/clients/list' title='Clients' hasBullet={true} />
          <AsideMenuItem to='/rdr/caids/list' title='CAIDs' hasBullet={true} />
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub
          to='/cdrn'
          title='Verifi CDRN'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/abstract/abs041.svg'
        >
          <AsideMenuItem to='/cdrn/cases/list' title='Cases' hasBullet={true} />
          <AsideMenuItem to='/cdrn/descriptors/list' title='Descriptors' hasBullet={true} />
          <AsideMenuItem to='/cdrn/clients/list' title='Clients' hasBullet={true} />
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub
          to='/oi'
          title='Verifi OI'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/abstract/abs023.svg'
        >
          <AsideMenuItem to='/oi/lookups/list' title='Order Lookup' hasBullet={true} />
          <AsideMenuItem to='/oi/caids/list' title='CAIDs' hasBullet={true} />
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub
          to='/beceipt'
          title='ICS'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/abstract/abs014.svg'
        >
          <AsideMenuItem to='/beceipt/transactions/list' title='Transactions' hasBullet={true} />
          <AsideMenuItem to='/beceipt/requests/list' title='Buyer Requests' hasBullet={true} />
          {/* <AsideMenuItem to='/beceipt/failed-emails/list' title='Failed Emails' hasBullet={true} /> */}
          {/* <AsideMenuItem to='/beceipt/clients/list' title='Clients' hasBullet={true} /> */}
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub
          to='/aml'
          title='AML Screening'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/abstract/abs026.svg'
        >
          <AsideMenuItem to='/aml/individual-screening/list' title='For Individual' hasBullet={true} />
          <AsideMenuItem to='/aml/business-screening/list' title='For Business' hasBullet={true} />
          <AsideMenuItem to='/aml/document-verification/list' title='Document Verification' hasBullet={true} />
          <AsideMenuItem to='/aml/clients/list' title='Clients' hasBullet={true} />
        </AsideMenuItemWithSub>

        {/* <AsideMenuItemWithSub
          to='/monitor'
          title='Monitor'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/electronics/elc001.svg'
        >
          <AsideMenuItem to='/monitor/duplicate/list' title='Duplicate Alerts' hasBullet={true} />
          <AsideMenuItem to='/monitor/duplicate-ethoca/list' title='Ethoca Duplicate Alerts' hasBullet={true} />
        </AsideMenuItemWithSub>

        <AsideMenuItemWithSub
          to='/settlement'
          title='Settlement'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/finance/fin001.svg'
        >
          <AsideMenuItem to='/settlement/duplicate-arn/list' title='ARN Duplicate Cases' hasBullet={true} />
          <AsideMenuItem to='/settlement/recall-rdr/list' title='RDR Recalled Cases' hasBullet={true} />
          <AsideMenuItem to='/settlement/clients/list' title='Clients' hasBullet={true} />
        </AsideMenuItemWithSub>

        {/* <AsideMenuItemWithSub
          to='/tld-log'
          title='TLD Log'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/files/fil001.svg'
        >
          <AsideMenuItem to='/tld-log/clients/list' title='Clients' hasBullet={true} />
        </AsideMenuItemWithSub> */}

        {haveAddBrandPermission && <AsideMenuItemWithSub
          to='/si'
          title='SiteInspect 2.0'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/abstract/abs021.svg'
        >
          <AsideMenuItem to='/si/brand/form' title='Add Brand' hasBullet={true} />
        </AsideMenuItemWithSub>}

        {/* <AsideMenuItemWithSub
          to='/users'
          title='Admin'
          header={true}
          fontIcon='bi-archive'
          icon='/media/icons/duotune/general/gen049.svg'
        >
          <AsideMenuItem to='/users/list' title='Users' hasBullet={true} />
        </AsideMenuItemWithSub> */}
      </div>
    </>
  )
}
